import { render, staticRenderFns } from "./ClientImport.vue?vue&type=template&id=1515596b&"
import script from "./ClientImport.vue?vue&type=script&lang=js&"
export * from "./ClientImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports